import React from "react";
import './header.sass';
import { header_ls } from '../const';
// import Logo from '../../media/img/myLogo.png';
import { HeaderSmart } from "./headerSmart";

export const Header = () => {
    return (
      <header id="gh">
          {/* <img src= {Logo} alt="#" id="headerImg"/> */}
          <a href='#gh' id="logoA">
            <div id='logo'>M.B</div>
          </a>
          <nav>
            {header_ls.map((item: { textHref : string, href : string }, index: number) => { 
              return (
              <a key={index} href={item.href} className="menus">{item.textHref}</a>
            )})}
          </nav>  

          <HeaderSmart />

      </header>
    );
  }